import React, { useState } from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/new-request.css";
import DonateService from "../services/DonateService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";


const Form = () => {

	const donate = new DonateService();

	const [ error, setError ] = useState("");
	const [ success, setSuccess ] = useState(false);
	const [ pending, setPending ] = useState(false);
	const [ input, setInput ] = useState({
		name: "",
		email: "",
		age: "",
		plan: "standard",
		whatsapp: "",
		instagram: "",
		description: ""
	});

	const handleInput = (e) => {
		setInput({
			...input,
			[e.target.name]: e.target.value
		})
	}

	const submit = async (e) => {
		e.preventDefault();
		setPending(true);

		try {

			await donate.createDonation(input.email, input.instagram, input.whatsapp);

			setSuccess(true);

		}
		catch(error) {
			setSuccess(false);
			setPending(false);
			setError(error);
		}
	}

	return (
		<>
			{ !success ? 
			<form id="new-request" onSubmit={e => submit(e)}>
				<h1>Submit a Donation Request!</h1>
				<p>To donate one of our plans to a child in need, please fill the current form.</p>
				{ error.length > 0 && <h3>{error}</h3> }
				<div>
					<label>Email: </label>
					<br />
					<input 
						required
						type="email" 
						name="email"
						placeholder="johnsmith@nofapguidance.web.app"
						disabled={pending}
						onChange={e => handleInput(e)}
					/>
				</div>
				<div>
					<label>WhatsApp Number(optional): </label>
					<br />
					<input 
						type="text" 
						name="whatsapp"
						placeholder="+XXXYYYZZZ"
						disabled={pending}
						onChange={e => handleInput(e)}
					/>
				</div>
				<div>
					<label>Instagram(optional): </label>
					<br />
					<input 
						type="text" 
						name="instagram"
						placeholder="@nofapguidance"
						disabled={pending}
						onChange={e => handleInput(e)}
					/>
				</div>
				<button 
					disabled={pending} 
					type="submit"
				>Submit Request</button>
			</form> : 
			<section id="success">
				<h1><FontAwesomeIcon icon={faCheckCircle}/></h1>
				<h2>Your request has been sent!</h2>
				<p>You will get a response shortly in your E-mail/Instagram/WhatsApp. Make sure to check your spam!</p>
			</section>
			}
		</>
	);

	
};

const DonateRequestPage = () => (
	<>
		<Navbar />
		<Form />
		<Footer />
	</>
);

export default DonateRequestPage;